import { PureComponent, type ReactNode } from "react";
import CSS from "csstype";

type TriangleDividerProps = {
  direction: string;
  background: string;
};

const triangleStyleLeft: CSS.Properties = {
  clipPath: "polygon(35% 100%, 0 0, 100% 0)",
  WebkitClipPath: "polygon(35% 100%, 0 0, 100% 0)",
};

const triangleStyleRight: CSS.Properties = {
  clipPath: "polygon(65% 100%, 0 0, 100% 0)",
  WebkitClipPath: "polygon(65% 100%, 0 0, 100% 0)",
};

export class TriangleDivider extends PureComponent<TriangleDividerProps> {
  render(): ReactNode {
    return (
      <div
        data-testid="triangleDivider"
        style={this.props.direction == "left" ? triangleStyleLeft : triangleStyleRight}
        className={`h-divider-mobile lg:h-divider-desktop z-0 ${this.props.background}`}
      />
    );
  }
}
